import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
const height = 50;
const velocity = 0.15;
const headerHeight = 75;
export const scrollTo = (htmlElement: HTMLElement) => {
  const targetTop = htmlElement.offsetTop - headerHeight;
  if (!window.requestAnimationFrame || true) {
    window.scrollTo(0, targetTop);
    return;
  }
  let start: number | null = null;
  let animationRequest: number | null = null;
  const pageYOffset = window.pageYOffset;
  const cancelAnimation = () => {
    if (animationRequest && window.cancelAnimationFrame) window.cancelAnimationFrame(animationRequest);
    document.removeEventListener('wheel', cancelAnimation);
    document.removeEventListener('touchstart', cancelAnimation);
  };
  const step = (time: number) => {
    if (start === null) start = time;
    const nextPageOffset = Math.max(0, pageYOffset - (time - start) / velocity);
    window.scrollTo(0, nextPageOffset);
    if (nextPageOffset !== 0) return (animationRequest = requestAnimationFrame(step));
    animationRequest = null;
    cancelAnimation();
  };
  animationRequest = requestAnimationFrame(step);
  document.addEventListener('wheel', cancelAnimation);
  document.addEventListener('touchstart', cancelAnimation);
};

export const scrollToAncher = (ancherName: string) => {
  const element = document.querySelector('#' + ancherName);
  if (element) scrollTo(element as HTMLElement);
};

export const Anchor = styled.div`
  transform: translateY(-75px);
`;
